import { ITireTruckImplement } from 'app/shared/model/tire-truck-implement.model';
import React from 'react';
import { Chip, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { DeleteRounded } from '@mui/icons-material';

interface Props {
  tireTruckImplements: ITireTruckImplement[];
  onClick?: (index: number) => void;
  compact?: boolean;
}

export const TireTableDetail = (props: Props) => {
  const { tireTruckImplements, onClick, compact } = props;
  const tireTruckImplementList = [...tireTruckImplements];

  return (
    <TableContainer>
      <Table size="small" sx={{ width: '100%', ...(compact ? {} : { tableLayout: 'fixed' }), fontSize: '0.73rem', '& td, & th': { fontSize: '0.73rem' } }}>
        <TableHead>
          <TableRow>
            <TableCell sx={compact ? { width: '40%' } : { width: '10%' }}>Pneu</TableCell>
            <TableCell align={compact ? 'left' : 'center'} sx={compact ? { width: '60%' } : { width: '30%' }}>
              Posição
            </TableCell>
            {!compact && <TableCell sx={{ width: '30%' }}>Marca</TableCell>}
            {!compact && <TableCell sx={{ width: '30%' }}>Modelo</TableCell>}
            {onClick && <TableCell sx={{ width: 90 }}>Remover</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {tireTruckImplementList
            .sort((a, b) => (a.position ?? 0) - (b.position ?? 0))
            .map((tti, i) => (
              <TableRow key={i} hover>
                <TableCell>{tti?.tire?.marking}</TableCell>
                <TableCell align={compact ? 'left' : 'center'}>
                  <Chip label={tti?.position} size="small" />
                </TableCell>
                {!compact && <TableCell>{tti?.tire?.tireModel?.tireManufacturer?.name}</TableCell>}
                {!compact && <TableCell>{tti?.tire?.tireModel?.name}</TableCell>}
                {onClick && (
                  <TableCell>
                    <IconButton color="error" size="small" onClick={() => onClick(i)}>
                      <DeleteRounded fontSize="small" />
                    </IconButton>
                  </TableCell>
                )}
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TireTableDetail;
